import React, { Component } from 'react'
import styles from './style.module.less'
import { getMerchantInfo } from '@util'

export default class extends Component {
  render() {
    const { name, hidden } = getMerchantInfo()
    return (
      <div className={styles.wrapper}>
        <img src="https://qnm.hunliji.com/FiUGW7jRo_pXzy_14vmW-Nrn_StY" />
        <div className={styles.right}>
          <div className={styles.title}>Hi，{name}：</div>
          <div className={styles.desc}>
            {(hidden == 1 || hidden == 2) &&
              '您的店铺因违反平台相关条例已被隐藏，无法在婚礼纪App显示，如有疑问请联系客服：400-159-9090。'}
            {hidden == 3 &&
              '当前店铺已隐藏，不在婚礼纪App显示，如需恢复请联系管理员激活店铺'}
          </div>
        </div>
      </div>
    )
  }
}
